
import { CalendarSettings } from "@/lib/supabase";

export const dbToCalendarSettings = (data: any): CalendarSettings => {
  return {
    id: data.id,
    created_at: data.created_at,
    updated_at: data.updated_at,
    user_id: data.user_id,
    startHour: data.start_hour,
    endHour: data.end_hour,
    workDays: data.work_days,
    unavailableSlots: data.unavailable_slots || {}
  };
};

export const calendarSettingsToDb = (settings: CalendarSettings) => {
  return {
    start_hour: settings.startHour,
    end_hour: settings.endHour,
    work_days: settings.workDays,
    unavailable_slots: settings.unavailableSlots || {},
    user_id: settings.user_id
  };
};
